module.exports = __webpack_public_path__ + "0f7c5b94f9dadb06dae28538c5b82bec.MP3";